import { BaseEntity } from "./BaseEntity";

export default class Channel extends BaseEntity {
	constructor(id: number, public name: string, public address: string) {
		super(id);
	}
}